import { useState } from "react";
import { Select, MenuItem } from "@mui/material";
import { FilterType, FilterDict } from "../types/filter";
import "./filter.scss";

export const useFilter = () => {
  const [valueDict, setValueDict] = useState<Record<string, string>>({});
  const setValue = (keyword: string, value: string) => {
    setValueDict((prev) => ({ ...prev, [keyword]: value }));
  };
  const deleteKeyword = (keyword: string) => {
    setValueDict((prev) => {
      const { [keyword]: _, ...rest } = prev;
      return rest;
    });
  };

  return { valueDict, setValue, deleteKeyword };
};

const Filter = ({
  keyword,
  value,
  filter,
  setValue,
}: {
  keyword: string;
  value: string;
  filter: FilterType;
  setValue: (k: string, v: string) => void;
}) => {
  return (
    <div className="filter">
      {filter.type === "default" && <input disabled />}
      {filter.type === "select" && (
        <Select
          variant="standard"
          displayEmpty
          value={
            filter.disabled
              ? filter.defaultValue
              : value || filter.options?.[0].value
          }
          disabled={filter.disabled}
          onChange={(e) => {
            setValue(keyword, e.target.value);
            if (filter.duplicateField) {
              filter.duplicateField.forEach((field) => {
                setValue(field, e.target.value);
              });
            }
          }}
        >
          {filter.options?.map((option) => (
            <MenuItem value={option.value}>{option.label}</MenuItem>
          ))}
        </Select>
      )}
      {filter.type === "input" && (
        <input
          type="text"
          value={value}
          disabled={filter.disabled}
          placeholder={filter.placeholder}
          onChange={(e) => {
            setValue(keyword, e.target.value);
            if (filter.duplicateField) {
              filter.duplicateField.forEach((field) => {
                setValue(field, e.target.value);
              });
            }
          }}
        />
      )}
    </div>
  );
};

export const MultipleFilter = ({
  filterDict,
  valueDict,
  setValue,
  columnCount,
}: {
  filterDict: FilterDict;
  valueDict: Record<string, string>;
  setValue: (keyword: string, value: string) => void;
  columnCount: number;
}) => {
  return (
    <div
      style={{
        display: "inline-grid",
        gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
        rowGap: "1rem",
      }}
    >
      {Object.entries(filterDict).map(([keyword, filter]) => (
        <div className="multiFilter">
          <label>{filter.label}: </label>
          <Filter
            key={keyword}
            keyword={keyword}
            value={valueDict[keyword]}
            filter={filter}
            setValue={setValue}
          />
        </div>
      ))}
    </div>
  );
};

export const SingleFilter = ({
  filterDict,
  valueDict,
  setValue,
  deleteKeyword,
}: {
  filterDict: FilterDict;
  valueDict: Record<string, string>;
  setValue: (keyword: string, value: string) => void;
  deleteKeyword: (keyword: string) => void;
}) => {
  const [keyword, setKeyword] = useState("");

  return (
    <div className="singleFilter">
      <Select
        className="filterType"
        displayEmpty
        value={keyword}
        variant="standard"
        onChange={(e) => {
          deleteKeyword(keyword);
          setKeyword(e.target.value);
          setValue(e.target.value, "");
        }}
      >
        {Object.entries(filterDict).map(([keyword, filter]) => (
          <MenuItem value={keyword}>{filter.label}</MenuItem>
        ))}
      </Select>
      {keyword !== undefined && keyword !== null && (
        <Filter
          keyword={keyword}
          value={valueDict[keyword]}
          filter={filterDict[keyword]}
          setValue={setValue}
        />
      )}
    </div>
  );
};
